import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import type { TokenResponse } from "@/lib/authBackend/trimble/tid/client";
import { buildTidSilentFrameUrl, isTidPopupMessageForAttempt, PROCORE_TID_SILENT_FRAME_NAME } from "@/lib/procore/tidPopup";
const SILENT_CHECK_TIMEOUT_MS = 5_000;
export interface SilentTidCheckHandlers {
  onComplete: (session: TokenResponse) => void;
  onFail: () => void;
}
export const useSilentTidFrameCheck = () => {
  const $ = _c(3);
  const cleanupRef = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => () => {
      cleanupRef.current?.();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    const startSilentCheck = (pathname, search, handlers) => {
      cleanupRef.current?.();
      const requestId = window.crypto.randomUUID();
      const iframe = document.createElement("iframe");
      iframe.name = PROCORE_TID_SILENT_FRAME_NAME;
      iframe.hidden = true;
      document.body.appendChild(iframe);
      if (!iframe.contentWindow) {
        iframe.remove();
        handlers.onFail();
        return;
      }
      let settled = false;
      const expectedOrigin = window.location.origin;
      const cleanup = () => {
        window.removeEventListener("message", onMessage);
        clearTimeout(timeout);
        iframe.remove();
        if (cleanupRef.current === cleanup) {
          cleanupRef.current = null;
        }
      };
      const settle = action => {
        if (settled) {
          return;
        }
        settled = true;
        cleanup();
        action();
      };
      function onMessage(event) {
        if (!iframe.contentWindow) {
          return;
        }
        if (!isTidPopupMessageForAttempt(event, iframe.contentWindow, requestId, expectedOrigin)) {
          return;
        }
        const message = event.data;
        settle(() => {
          if (message.success) {
            handlers.onComplete(message.session);
            return;
          }
          console.error("Trimble silent SSO check reported failure", {
            requestId,
            error: message.error
          });
          handlers.onFail();
        });
      }
      window.addEventListener("message", onMessage);
      const timeout = setTimeout(() => {
        settle(() => {
          console.error("Trimble silent SSO check timed out without a response", {
            requestId
          });
          handlers.onFail();
        });
      }, SILENT_CHECK_TIMEOUT_MS);
      cleanupRef.current = cleanup;
      iframe.src = buildTidSilentFrameUrl(pathname, search, requestId);
    };
    t2 = {
      startSilentCheck
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};